export default __webpack_public_path__ + "static/media/logo-element-orange.7aa02a5f.svg";